module.exports = __webpack_public_path__ + "img/qrCode_03.1159d6dd.jpg";